import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { renderFields } from '../../utils/RenderUtil.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';

var FieldGroup = /*#__PURE__*/function (_React$Component) {
  function FieldGroup(props) {
    var _this;

    _classCallCheck(this, FieldGroup);

    _this = _callSuper(this, FieldGroup, [props]);
    _this.renderFields = _this.renderFields.bind(_this);
    return _this;
  }

  _inherits(FieldGroup, _React$Component);

  return _createClass(FieldGroup, [{
    key: "renderFields",
    value: function renderFields$1() {
      return renderFields(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var disabledStyle = {
        pointerEvents: 'none',
        opacity: 0.5
      };
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var dataAttributes = pickDataAttributes(this.props);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: className,
        style: disabled ? disabledStyle : null
      }, dataAttributes), this.renderFields());
    }
  }]);
}(React.Component);

_defineProperty(FieldGroup, "propTypes", {
  className: PropTypes.string,
  disabled: PropTypes.bool
});

FieldGroup.displayName = "FieldGroup";
export { FieldGroup };